import { Plan, usePlans } from '@melio/subscriptions-api';
import { useSubscription } from '@melio/subscriptions-sdk';
import { findIndex } from 'lodash';

const isFreePlan = (plan: Plan) => plan.billingCycles.monthly.price === 0;
const isPaidPlan = (plan: Plan) => !isFreePlan(plan);

export const useSubscriptionPlanTier = () => {
  const { data: plans, isFetching } = usePlans();
  const { subscription } = useSubscription();

  const getPlanTier = (planId: string) => findIndex(plans, (plan) => plan.id === planId) + 1;

  const isUpgradedPlan = (planId: string) => getPlanTier(planId) > getPlanTier(subscription.planId);
  const isDowngradedPlan = (planId: string) => getPlanTier(planId) < getPlanTier(subscription.planId);

  const freePlan = plans?.find(isFreePlan);
  const firstPaidPlan = plans?.find(isPaidPlan);

  const currentPlan = plans?.find((plan) => plan.id === subscription.planId);

  return {
    isFetching,
    currentPlan,
    freePlan,
    firstPaidPlan,
    getPlanTier,
    isUpgradedPlan,
    isDowngradedPlan,
  };
};
